<ng-container>
  <section class="tw-px-4 tw-bg-gray-50 tw-pt-4 tw-pb-5 tw-font-display" (click)="openFeedback()">
    <div class="tw-bg-yellow-100 tw-flex tw-flex-col tw-items-center tw-pt-6 tw-rounded-3 tw-pb-2 tw-border-[1px] tw-border-gray-50 tw-shadow-z4 tw-overflow-x-clip">
      <h1 class="tw-text-500 tw-font-bold tw-mb-1 tw-text-center" i18n="@@shareYourFeedback">Share your feedback</h1>
      <p class="tw-text-gray-500 tw-text-200 tw-text-center tw-w-72" i18n="@@yourInputIsValuable">Your input is valuable in helping us better understand your needs.</p>
      <img src="/assets/images/nps-banner-oct-2024.svg" alt="banner" class="tw-mt-3 tw-scale-105"/>
    </div>
  </section>
</ng-container>
